/* eslint-disable */
// ============================================================
//  i18n — chargement des traductions à la demande
//
//  29 août 2026. Avant : les 7 langues (355 ko de source) partaient dans le
//  bundle principal chez TOUS les utilisateurs. Un francophone téléchargeait
//  six langues qu'il ne verrait jamais, et chaque langue ajoutée alourdissait
//  l'app pour tout le monde.
//
//  Maintenant : le FRANÇAIS est embarqué, les six autres sont chargées à la
//  demande. Ajouter une 8e langue ne coûte plus rien aux utilisateurs actuels.
//
//  ⚠️ POURQUOI LE FRANÇAIS EST EMBARQUÉ ET PAS CHARGÉ COMME LES AUTRES :
//  c'est le filet de sécurité. `useLang` (utils.js) et la landing font déjà
//  `T[lang] || T.fr`. Donc si un chargement échoue — réseau coupé, chunk
//  périmé après un déploiement — l'app s'affiche en français au lieu de
//  planter sur un écran blanc. C'est exactement le type de panne qui a déjà
//  frappé ce projet plusieurs fois.
// ============================================================

import fr from "./fr";

// Langues déjà en mémoire. Le français y est dès le départ.
const LOADED = { fr };

// `T` est cet objet lui-même : quand une langue arrive, elle apparaît ici.
// Les appelants font T[lang] || T.fr, donc une langue absente = repli, jamais d'erreur.
export const T = LOADED;

// import() dynamique : webpack en fait un chunk séparé par langue.
// Ne jamais remplacer par un import statique — les 7 langues repartiraient
// dans le bundle principal et tout le gain serait perdu.
const LOADERS = {
  en: () => import(/* webpackChunkName: "i18n-en" */ "./en"),
  de: () => import(/* webpackChunkName: "i18n-de" */ "./de"),
  es: () => import(/* webpackChunkName: "i18n-es" */ "./es"),
  it: () => import(/* webpackChunkName: "i18n-it" */ "./it"),
  pt: () => import(/* webpackChunkName: "i18n-pt" */ "./pt"),
  nl: () => import(/* webpackChunkName: "i18n-nl" */ "./nl"),
};

export const AVAILABLE_LANGS = ["fr", ...Object.keys(LOADERS)];

// Charge une langue si besoin. Ne lève jamais : en cas d'échec on renvoie
// false et l'app continue en français.
export async function loadLang(lang) {
  if (!lang || LOADED[lang]) return true;
  const load = LOADERS[lang];
  if (!load) return false;
  try {
    const mod = await load();
    LOADED[lang] = mod.default || mod;
    return true;
  } catch (e) {
    console.warn("[i18n] chargement de", lang, "impossible — on reste en français", e);
    return false;
  }
}
